export default __webpack_public_path__ + "static/orange_frog_mobile-d6ddcbc66030c9ecb4a1f0dcf9536466.png";